module.exports = __webpack_public_path__ + "img/partner23.cd734073.png";